import axios from "axios";

//Figuring out a way to make baseURL configurable.
//axios.defaults.baseURL = "http://localhost:4442";
axios.defaults.baseURL = window.location.origin;
class HttpClient {
    get = async (url = "", headers = {}, params = {}) => {
        let config = {
            headers: headers,
            params: params
        }
        return await axios.get(`${url}`, config);
    }
    getAttachment = async (url = "", headers = {}, params = {}) => {
        let config = {
            headers: headers,
            params: params,
            responseType: 'blob'
        }
        return await axios.get(`${url}`, config);
    }

    post = (url = "", body = "", headers = {}) => {
        return axios.post(`/${url}`, body , { headers: headers })
    }

    put = (url = "", headers = {}, params = "") => {
        return axios.put(`/${url}`, { params }, { ...headers })
    }

    delete = (url = "", headers = {}, params = "") => {
        return axios.delete(`/${url}`, { params }, { ...headers })
    }
};

export default new HttpClient();